/** A single labelled count card, shared by the tracking modal and the history details. */
export default function BulkInviteCountStat({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-lg border border-gray-200 dark:border-[#2A2A2A] p-3 text-center">
      <p className="text-xl font-semibold">{value.toLocaleString()}</p>
      <p className="text-xs text-gray-500 dark:text-[#AFAFAF]">{label}</p>
    </div>
  )
}
